import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import {fetchSubmitForm, fetchSubmitFormFailed, fetchSubmitFormSuccess} from '../common/submitForm';
import { getUserId } from '../account/userData';
import { SUB_ROLES, fetchGetSubRoles } from '../account/role';
import { hideModal } from '../common/activeModal';
import { logout, onForbidden } from '../account/login';
import _ from 'lodash';

//- Actions
export const fetchGetAccreditationGroupFailed = createAction('FETCH_GET_ACCREDITATION_GROUP_FAILED');
export const fetchGetAccreditationGroupSuccess = createAction('FETCH_GET_ACCREDITATION_GROUP_SUCCESS');
export const fetchGetAccreditationGroup = createAction(
    'FETCH_GET_ACCREDITATION_GROUP',
    id => Api.getAccreditationGroup(id),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationGroupSuccess,
        onFail: fetchGetAccreditationGroupFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetAccreditationGroupValidatorsSuccess = createAction('FETCH_GET_ACCREDITATION_GROUP_VALIDATORS_SUCCESS');
export const fetchGetAccreditationGroupValidators = createAction(
    'FETCH_GET_ACCREDITATION_GROUP_VALIDATORS',
    id => Api.getEmployeesByAccreditationGroupAndRole(id, SUB_ROLES.VALIDATOR),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationGroupValidatorsSuccess,
        onFail: fetchGetAccreditationGroupFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetAccreditationGroupInsertersSuccess = createAction('FETCH_GET_ACCREDITATION_GROUP_INSERTERS_SUCCESS');
export const fetchGetAccreditationGroupInserters = createAction(
    'FETCH_GET_ACCREDITATION_GROUP_INSERTERS',
    id => Api.getEmployeesByAccreditationGroupAndRole(id, SUB_ROLES.INSERTER),
    () => ({
        apiCall: true,
        onSuccess: fetchGetAccreditationGroupInsertersSuccess,
        onFail: fetchGetAccreditationGroupFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetAccreditationGroupData = () => (dispatch, getState) => {
    let accreditationGroupId = getAccreditationGroupId(getState());
    if (!_.isNil(accreditationGroupId) && accreditationGroupId !== '') {
        dispatch(fetchGetAccreditationGroup(accreditationGroupId));
        dispatch(fetchGetAccreditationGroupInserters(accreditationGroupId));
        dispatch(fetchGetAccreditationGroupValidators(accreditationGroupId));
    } else {
        dispatch(fetchGetAccreditationGroupFailed("ID_IS_NULL"))
    }
};

export const updateAccreditationGroupEmployees = (employeeId) => (dispatch, getState) => {
    let accreditationGroupId = getAccreditationGroupId(getState());
    dispatch(fetchGetAccreditationGroupInserters(accreditationGroupId));
    dispatch(fetchGetAccreditationGroupValidators(accreditationGroupId));
    dispatch(fetchSubmitFormSuccess());
    if (employeeId === getUserId(getState())) {
        dispatch(fetchGetSubRoles());
    }
};

export const onChangeEmployeesInAccreditationGroupSuccess = (employeeId) => () => dispatch => {
    dispatch(hideModal());
    dispatch(updateAccreditationGroupEmployees(employeeId));
};

export const fetchAddEmployeeToAccreditationGroup = (groupId, employeeId, role) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onAddEmployeeToAccreditationGroup(groupId, employeeId, role));
};

export const onAddEmployeeToAccreditationGroup = createAction(
    'FETCH_ADD_EMPLOYEE_TO_ACCREDITATION_GROUP',
    (groupId, employeeId, role) => Api.addEmployeeToAccreditationGroup(groupId, employeeId, role),
    (groupId, employeeId) => ({
        apiCall: true,
        onSuccess: onChangeEmployeesInAccreditationGroupSuccess(employeeId),
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchRemoveEmployeeFromAccreditationGroup = (groupId, employeeId, role) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(removeEmployeeFromAccreditationGroup(groupId, employeeId, role));
};

export const removeEmployeeFromAccreditationGroup = createAction(
    'FETCH_REMOVE_EMPLOYEE_FROM_ACCREDITATION_GROUP',
    (groupId, employeeId, role) => Api.removeEmployeeFromAccreditationGroup(groupId, employeeId, role),
    (groupId, employeeId) => ({
        apiCall: true,
        onSuccess: onChangeEmployeesInAccreditationGroupSuccess(employeeId),
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchEditAccreditationGroup = (groupId, data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onEditAccreditationGroup(groupId, data));
};
export const onEditAccreditationGroupSuccess = () => dispatch => {
    dispatch(hideModal());
    dispatch(fetchGetAccreditationGroupData());
    dispatch(fetchSubmitFormSuccess());
};
export const onEditAccreditationGroup = createAction(
    'FETCH_EDIT_ACCREDITATION_GROUP',
    (groupId, data) => Api.editAccreditationGroup(groupId, data),
    () => ({
        apiCall: true,
        onSuccess: onEditAccreditationGroupSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setAccreditationGroupId = createAction('ACCREDITATION_GROUP_ID_SET', id => id);
export const resetAccreditationGroupData = createAction('ACCREDITATION_GROUP_DATA_RESET');

//- State
const initialState = {
    error: null,
    fetching: false,
    success: false,
    data: null,
    id: null
};

//- Reducers
export default handleActions({
    ACCREDITATION_GROUP_ID_SET: (state, action) => {
        return {...state, id: action.payload};
    },
    FETCH_GET_ACCREDITATION_GROUP: (state) => {
        return {...state, error: null, fetching: true, success: false};
    },
    FETCH_GET_ACCREDITATION_GROUP_FAILED: (state, action) => {
        return {...state, error: action.payload, fetching: false, success: false};
    },
    FETCH_GET_ACCREDITATION_GROUP_SUCCESS: (state, action) => {
        return {...state, error: null, fetching: false, success: true, data: {...state.data, ...action.payload}}
    },
    FETCH_GET_ACCREDITATION_GROUP_INSERTERS_SUCCESS: (state, action) => {
        return {...state, error: null, fetching: false, success: true, data: {...state.data, inserters: action.payload.content}};
    },
    FETCH_GET_ACCREDITATION_GROUP_VALIDATORS_SUCCESS: (state, action) => {
        return {...state, error: null, fetching: false, success: true, data: {...state.data, validators: action.payload.content}};
    },
    ACCREDITATION_GROUP_DATA_RESET: (state) => {
        return {...state, data: null}
    }
}, initialState);

//- Selectors
export const getAccreditationGroup = state => state.accreditationGroup;

export const loadingAccreditationGroup = state => {
    return getAccreditationGroup(state).fetching ||
        _.isNil(getAccreditationGroup(state).data) ||
        _.isNil(getAccreditationGroup(state).data.inserters) ||
        _.isNil(getAccreditationGroup(state).data.validators) ||
        _.isNil(getAccreditationGroup(state).data.name);
};

export const getFetchingErrorAccreditationGroup = state => getAccreditationGroup(state).error;

export const getAccreditationGroupData = state => {
    return getAccreditationGroup(state).data;
};

export const getAccreditationGroupName = state => {
    if (_.isNil(getAccreditationGroupData(state))) {
        return null;
    }

    return getAccreditationGroupData(state).name;
};

export const getAccreditationGroupId = state => getAccreditationGroup(state).id;


// WEBPACK FOOTER //
// ./src/reducers/organization/accreditationGroup.js